import React, { FC } from "react";
import { FieldErrors, FieldValues, UseFormRegister } from "react-hook-form";
import { IBasicData } from "../types/IFormData";

interface FormInputProps {
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
  basicData: IBasicData;
  max?: string;
}

const FormInput: FC<FormInputProps> = ({
  errors,
  register,
  basicData,
  max,
}) => {
  return (
    <div className={`${basicData.name === "address" ? "sm:col-span-2" : ""}`}>
      <label
        className="block text-sm font-medium mb-1"
        htmlFor={basicData.name}
      >
        {basicData.label}
        {errors[basicData.name]?.message && (
          <span className="ml-1 text-primary-dark font-semibold">*</span>
        )}
      </label>
      <input
        type={basicData.inputType}
        id={basicData.name}
        className="w-full p-2 border border-gray-300 rounded"
        placeholder=""
        max={max}
        {...register(basicData.name, {
          required: basicData.requiredErrorMessage,
          pattern: {
            value: basicData.validationPatternValue
              ? basicData.validationPatternValue
              : /.*/,
            message: basicData.errorMessage ? basicData.errorMessage : "",
          },
        })}
      />
      {basicData.descriptionMessage && (
        <p className="text-sm text-gray-500 mt-1">
          {basicData.descriptionMessage}
        </p>
      )}
      {typeof errors[basicData.name]?.message === "string" && (
        <span className="text-primary-dark text-sm font-medium">{`${
          errors[basicData.name]?.message
        }`}</span>
      )}
    </div>
  );
};

export default FormInput;
